export default __webpack_public_path__ + "static/media/smallvan.dcd5e8fe.svg";